{
  "title": "Проверка эссе",
  "subtitle": "Загрузи эссе или вставь текст — получишь оценку по 6 критериям и аннотации прямо в тексте.",
  "list": {
    "title": "Все эссе",
    "subtitle": "Загрузи эссе или вставь текст — получишь оценку по 6 критериям и аннотации прямо в тексте.",
    "empty": {
      "title": "Ещё нет ни одного эссе",
      "subtitle": "Загрузи текст или PDF — получишь оценку за 1–2 минуты.",
      "cta": "Загрузить эссе"
    },
    "search": "Поиск по названию…",
    "count": "{count, plural, one {# эссе} few {# эссе} other {# эссе}}",
    "wordCount": "{count, plural, one {# слово} few {# слова} other {# слов}}",
    "errorTitle": "Не удалось загрузить список эссе",
    "errorSubtitle": "Проверь соединение или попробуй позже.",
    "retry": "Повторить",
    "filtered": "Ничего не найдено",
    "filteredReset": "Сбросить фильтры"
  },
  "filter": {
    "status": "Статус",
    "all": "Все"
  },
  "status": {
    "draft": "Черновик",
    "queued": "В очереди",
    "grading": "Проверка",
    "ready": "Готово",
    "failed": "Ошибка"
  },
  "actions": {
    "open": "Открыть",
    "downloadPdf": "Скачать PDF",
    "delete": "Удалить"
  },
  "new": {
    "cta": "Новое эссе",
    "title": "Новое эссе",
    "subtitleV3": "Напиши, вставь или загрузи файл. Название подбирается автоматически.",
    "tooShort": "Текст эссе слишком короткий. Минимум 50 слов.",
    "untitled": "Эссе",
    "tab": {
      "write": "Написать",
      "upload": "Загрузить PDF",
      "paste": "Вставить",
      "text": "Текст",
      "file": "Файл"
    },
    "essayTitleLabel": "Название",
    "essayTitlePlaceholder": "Эссе по обществознанию",
    "bodyLabel": "Текст эссе",
    "bodyPlaceholder": "Начни писать или вставь текст…",
    "bodyPlaceholderV2": "Напиши или вставь сюда текст эссе…",
    "uploadHint": "Перетащи PDF или DOCX",
    "uploadCta": "Выбрать файл",
    "uploadComingSoon": "Загрузка файла — скоро",
    "uploadComingSoonHint": "Пока вставьте текст эссе во вкладку «Вставить текст»",
    "file": {
      "dropHint": "Перетащи файл или нажми для выбора",
      "pickHint": "Нажми, чтобы выбрать файл",
      "formats": "PDF, DOCX, TXT, MD — до 10 МБ",
      "extracting": "Извлекаем текст…",
      "extracted": "Текст извлечён ({words} {words, plural, one {слово} few {слова} other {слов}})",
      "extractError": "Не удалось извлечь текст из файла",
      "networkError": "Ошибка загрузки файла",
      "tooLarge": "Файл больше 10 МБ",
      "clear": "Очистить"
    },
    "submit": "Отправить на проверку",
    "cancel": "Отмена",
    "wordCount": "{count, plural, one {# слово} few {# слова} other {# слов}}"
  },
  "rename": {
    "label": "Название эссе",
    "hint": "Переименовать",
    "error": "Не удалось переименовать"
  },
  "detail": {
    "back": "К списку",
    "score": "Итог",
    "gradedAt": "Проверено",
    "downloadPdf": "Скачать PDF",
    "dispute": "Оспорить оценку",
    "disputeStatus": "Жалоба отправлена",
    "disputeAlreadyOpen": "Жалоба уже на рассмотрении модератором",
    "retry": "Попробовать снова",
    "loading": "Загружаем эссе…",
    "noTitle": "Без названия",
    "maxScore": "Макс: {score}",
    "scoreUnit": "{score} б.",
    "gradingMissingTitle": "Оценка недоступна",
    "gradingMissingSubtitle": "AI-оценка не сгенерирована. Запусти перепроверку, чтобы получить балл и аннотации.",
    "regrade": "Перепроверить",
    "regenerate": "Переразметить",
    "manualReview": "Требуется ручная проверка",
    "manualReviewSubtitle": "Эссе попало в очередь модерации. Финальная оценка может измениться.",
    "aiDetection": "Детекция ИИ: {percent}%",
    "tab": {
      "essay": "Эссе",
      "criteria": "Критерии",
      "summary": "Резюме"
    },
    "summary": "Резюме",
    "strengths": "Сильные стороны",
    "improvements": "Зоны роста",
    "criteria": {
      "title": "Критерии",
      "level": "Уровень",
      "feedback": "Комментарий",
      "details": "Подробнее"
    },
    "annotations": {
      "title": "Аннотации",
      "kind": {
        "praise": "Сильно",
        "issue": "Проблема",
        "suggestion": "Предложение",
        "question": "Вопрос",
        "reference": "Ссылка"
      },
      "criterion": "Критерий",
      "suggestedRewrite": "Вариант переписать",
      "empty": "AI не оставил аннотаций"
    },
    "processing": {
      "title": "Эссе проверяется",
      "subtitle": "Это занимает 1–2 минуты. Можешь закрыть страницу — придёт уведомление.",
      "steps": {
        "extract": "Извлечение текста",
        "analyze": "Анализ структуры",
        "annotate": "Создание аннотаций",
        "score": "Подсчёт баллов"
      }
    },
    "errorTitle": "Не удалось загрузить эссе",
    "failedTitle": "Проверка не удалась",
    "failedSubtitle": "Попробуй отправить эссе ещё раз.",
    "scoreOf": "Оценка"
  },
  "report": {
    "title": "Отчёт",
    "download": "Скачать PDF",
    "open": "Открыть в новой вкладке",
    "loading": "Готовим отчёт…",
    "share": "Поделиться с преподавателем",
    "mobileHint": "Открой отчёт в браузере для просмотра.",
    "preparing": "Готовлю…",
    "pending": "PDF готовится…"
  },
  "dispute": {
    "title": "Не согласен с оценкой?",
    "subtitle": "Опиши, с каким критерием или общей оценкой ты не согласен. Модератор рассмотрит запрос.",
    "criterionLabel": "Критерий",
    "criterionPlaceholder": "Выбери критерий",
    "overall": "Общая оценка",
    "reasonLabel": "Почему не согласен",
    "reasonPlaceholder": "Например: «AI не учёл, что во втором абзаце я использовал конкретный пример из истории...».",
    "minChars": "Минимум 10 символов",
    "suggestedScoreLabel": "Какой балл считаешь справедливым (опц.)",
    "submit": "Отправить",
    "cancel": "Отмена",
    "sent": "Жалоба отправлена",
    "sentHint": "Модератор рассмотрит её в течение 2 рабочих дней",
    "alreadyOpen": "Жалоба уже отправлена",
    "error": "Не удалось отправить",
    "flowHint": "Модератор сверит оценку с твоим аргументом и критериями оценки. Ответ — в течение 2 рабочих дней, придёт уведомлением."
  },
  "regrade": {
    "title": "Запустить перепроверку?",
    "description": "AI заново оценит эссе и пересоздаст аннотации в тексте. Текущие аннотации будут заменены. Эта операция учитывается в квоте.",
    "confirm": "Перепроверить"
  },
  "score": {
    "pending": "—",
    "label": "Балл",
    "excellent": "Отличная работа",
    "good": "Хороший результат",
    "improving": "Есть над чем поработать",
    "needsWork": "Требует серьёзной доработки"
  },
  "toast": {
    "ready": "Эссе оценено",
    "readyHint": "Итоговый балл: {score} из 100",
    "reportReady": "PDF отчёт готов",
    "reportReadyHint": "Кнопка «Скачать PDF» теперь доступна",
    "pdfNotReady": "PDF ещё не готов",
    "pdfError": "Не удалось получить PDF",
    "regradeStarted": "Перепроверка запущена",
    "regradeStartedHint": "Подождите 30–60 секунд",
    "regradeError": "Не удалось запустить",
    "created": "Эссе отправлено на проверку",
    "createError": "Не удалось создать эссе",
    "deleted": "Эссе удалено",
    "deleteError": "Не удалось удалить"
  },
  "criteria": {
    "thesis": "Тезис",
    "structure": "Структура",
    "arguments": "Аргументация",
    "evidence": "Доказательства",
    "style": "Стиль и язык",
    "grammar": "Грамматика и пунктуация",
    "originality": "Оригинальность"
  },
  "delete": {
    "title": "Удалить эссе?",
    "subtitle": "Эссе и отчёт попадут в корзину на 30 дней.",
    "confirm": "Удалить",
    "cancel": "Отмена"
  },
  "errors": {
    "ESSAY_TOO_SHORT": "Текст эссе слишком короткий. Минимальный объём — 50 слов.",
    "ESSAY_NOT_FOUND": "Эссе не найдено.",
    "ESSAY_ALREADY_IN_PROGRESS": "Эссе уже проверяется в данный момент.",
    "ESSAY_IS_GRADING": "Эссе сейчас находится на проверке.",
    "ESSAY_NOT_GRADED": "Эссе ещё не проверено.",
    "ESSAY_NOT_GRADED_YET": "Эссе ещё не оценено.",
    "aggregate_parse_failed": "Произошла ошибка при анализе структуры оценок. Мы уже работаем над исправлением, пожалуйста, попробуйте перепроверить работу позже.",
    "aggregate_no_criteria": "Модели не удалось выделить критерии для оценки. Пожалуйста, попробуйте запустить перепроверку.",
    "aggregate_no_feedback": "Модель вернула пустой отзыв. Пожалуйста, попробуйте запустить перепроверку."
  },
  "intro": {
    "title": "Здесь ИИ проверяет, а не пишет",
    "body": "Единственный раздел, где оценивают ваш текст, а не создают новый. Разбор можно дополнить своими пометками и запросить перепроверку.",
    "bullets": [
      "Принимает pdf, docx, txt и markdown или вставленный текст",
      "Свои пометки ложатся поверх замечаний ИИ",
      "Итог выгружается в PDF с чеклистом правок"
    ]
  }
}
